exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-2b65ddf6]{border:0.01333rem solid #a6cf53;padding:0.06667rem 0.13333rem}.active[data-v-2b65ddf6]{background-color:#a6cf53;color:#fff}", ""]);

// exports
